import {
  Anchor,
  AnchorProps,
  Breadcrumbs as BreadcrumbsMantine,
  BreadcrumbsProps as BreadcrumbsMantineProps,
  ElementProps,
} from '@mantine/core';
import { IconChevronRight } from 'ui-icons';

import classes from './Breadcrumbs.module.css';

const BreadcrumbsDefaults = BreadcrumbsMantine.extend({
  defaultProps: {
    separator: <IconChevronRight size={12} />,
    separatorMargin: 4,
  },
  classNames: {
    breadcrumb: classes.breadcrumb,
    separator: classes.separator,
  },
});

interface TheAnchorProps extends AnchorProps, ElementProps<'a', keyof AnchorProps> {}

interface BreadcrumbSegment extends Omit<TheAnchorProps, 'href'> {
  title: string;
  onClick: React.MouseEventHandler<HTMLAnchorElement> | undefined;
}

interface BreadcrumbsProps extends Omit<BreadcrumbsMantineProps, 'children'> {
  segments: (string | BreadcrumbSegment)[];
}

const Breadcrumbs = ({ segments, ...rest }: BreadcrumbsProps) => {
  return (
    <BreadcrumbsMantine {...rest}>
      {segments.map((segment) => {
        if (typeof segment === 'string') {
          return segment;
        }

        const { title, onClick, ...segmentProps } = segment;

        return (
          <Anchor key={title} onClick={onClick} {...segmentProps}>
            {title}
          </Anchor>
        );
      })}
    </BreadcrumbsMantine>
  );
};

export { Breadcrumbs, BreadcrumbsDefaults };
export type { BreadcrumbsProps };
